(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2197],{

/***/ 394:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/404",
      function () {
        return __webpack_require__(1635);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1635:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2962);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _components_Header__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(798);
/* harmony import */ var _components_Footer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3193);
/* harmony import */ var _styles_modules_404_404_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2979);
/* harmony import */ var _styles_modules_404_404_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_styles_modules_404_404_module_scss__WEBPACK_IMPORTED_MODULE_6__);







var Page404 = function() {
    /** TEMPLATE */ return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .NextSeo */ .PB, {
                title: "404 — Страница не найдена",
                description: "К сожалению, запрашиваемая Вами страница не найдена. Пожалуйста, перейдите в существующий раздел",
                openGraph: {
                    url: "https://".concat("baza.estate"),
                    type: "website",
                    title: "404 — Страница не найдена",
                    description: "К сожалению, запрашиваемая Вами страница не найдена. Пожалуйста, перейдите в существующий раздел",
                    images: [
                        {
                            url: "/images/og-preview.png"
                        }
                    ],
                    site_name: "Baza.estate - база недвижимости"
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Header__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("main", {
                className: "core",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                    className: "block",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: [
                            "fixed",
                            (_styles_modules_404_404_module_scss__WEBPACK_IMPORTED_MODULE_6___default().content)
                        ].filter(Boolean).join(" "),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                className: (_styles_modules_404_404_module_scss__WEBPACK_IMPORTED_MODULE_6___default().contentTitle),
                                children: "Страница не найдена"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_styles_modules_404_404_module_scss__WEBPACK_IMPORTED_MODULE_6___default().contentDescription),
                                children: "Возможно, у вас опечатка в адресе страницы, или её просто не существует :("
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_styles_modules_404_404_module_scss__WEBPACK_IMPORTED_MODULE_6___default().contentImage),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                    src: "/images/404.svg",
                                    layout: "fill",
                                    objectFit: "cover",
                                    alt: "Страница не найдена"
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Footer__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {})
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Page404);


/***/ }),

/***/ 2979:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"content":"__404_content__gydxH","contentTitle":"__404_contentTitle__RoLPc","contentDescription":"__404_contentDescription__lYUQb","contentImage":"__404_contentImage__H6X75"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [41,2962,5675,798,3193,9774,2888,179], function() { return __webpack_exec__(394); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);